import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Mui } from '@osu/react-ui';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useAlertHandling } from '../../../Common/hooks/useAlertHandling';
import { graphqlApi } from '../../../services/graphql/api';
import {
  ASSIGN_APPLICATION,
  ASSIGN_TRAINEE,
  CLEAR_NOTIFY_ADMIN,
  CREATE_TRAINING,
  EDIT_TRAINING,
  MENU_CHANGE, NOTIFY_ADMIN,
  OVERRIDE_RECOMMENDATION,
  REASSIGN_APPLICATION,
  REPORT_CONFLICT,
  RESTART_APPLICATION,
  SAVE_REVIEW,
  SELECT_COMPLETEDBYDATE,
  SELECT_REVIEWER, SELECT_SECOND_REVIEWER,
  UNASSIGN_APPLICATION, UNASSIGN_TRAINEE,
  UPDATE_PRIORITY
} from '../../../actions-index';
import { createTraining as createTrainingAction } from '../../../services/graphql/slices/applicantActionsSlice';
import { unassignTrainee as unassignTraineeAction } from '../../../services/graphql/slices/applicantActionsSlice';
import { editTraining as editTrainingAction } from '../../../services/graphql/slices/applicantActionsSlice';
import { saveReview as saveReviewAction } from '../../../services/graphql/slices/applicantActionsSlice';
import { notifyAdmin as notifyAdminAction } from '../../../services/graphql/slices/applicantActionsSlice';
import { clearNotifyAdmin as clearNotifyAdminAction } from '../../../services/graphql/slices/applicantActionsSlice';
import { restartApplication as restartApplicationAction } from '../../../services/graphql/slices/applicantActionsSlice';
import { updatePriority as updatePriorityAction } from '../../../services/graphql/slices/applicantActionsSlice';
import { assignApplication as assignApplicationAction } from '../../../services/graphql/slices/manageApplicationsSlice';
import { unassignApplication as unassignApplicationAction } from '../../../services/graphql/slices/manageApplicationsSlice';
import { reassignApplication as reassignApplicationAction } from '../../../services/graphql/slices/manageApplicationsSlice';
import { reportConflict as reportConflictAction } from '../../../services/graphql/slices/reportsSlice';
import { ERROR_CONSTS, STATUS } from '../../../util/constants';
import AutoComplete from './AutoComplete';
import Dialog from './Dialog';
import Menu from './Menu';
import ClearNotifyAdminDialogContent from './components/ClearNotifyAdminDialogContent';
import CreateTrainingDialogContent from './components/CreateTrainingDialogContent';
import NotifyAdminDialogContent from './components/NotifyAdminDialogContent';
import UnassignTraineeDialogContent from './components/UnassignTraineeDialogContent';
import EditTrainingDialogContent from './components/EditTrainingDialogContent';
import useGetSelector from './hooks/useGetSelector';
import actionsReducer from './util';

const defaultState = {
  reviewer: '',
  reviewerTwo: '',
  completedByDate: getDefaultCompletedByDate(),
  dialog: {
    open: false,
    type: '',
    title: '',
    description: '',
    actions: [],
  },
};

function getDefaultCompletedByDate() {
    const date = new Date();
    const numberOfDaysInFuture = 7;
    date.setDate(date.getDate() + numberOfDaysInFuture);
    date.setHours(0, 0, 0, 0);
    return date;
}

const Actions = ({ pageAppHeader, isTraining, reviewers = [] }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  // Helper to dispatch slice action creators by dialog type
  const dispatchByType = (actionType, payload) => {
    const actionCreatorMap = {
      [SAVE_REVIEW]: saveReviewAction,
      [ASSIGN_APPLICATION]: assignApplicationAction,
      [UNASSIGN_APPLICATION]: unassignApplicationAction,
      [REASSIGN_APPLICATION]: reassignApplicationAction,
      [REPORT_CONFLICT]: reportConflictAction,
      [RESTART_APPLICATION]: restartApplicationAction,
      [NOTIFY_ADMIN]: notifyAdminAction,
      [CLEAR_NOTIFY_ADMIN]: clearNotifyAdminAction,
      [CREATE_TRAINING]: createTrainingAction,
      [UNASSIGN_TRAINEE]: unassignTraineeAction,
      [EDIT_TRAINING]: editTrainingAction,
      [UPDATE_PRIORITY]: updatePriorityAction,
    };
    const creator = actionCreatorMap[actionType];
    if (creator) {
      dispatch(creator(payload));
    }
  };
 
  const [actionState, setActionState] = useReducer(
    actionsReducer,
    defaultState
  );
  const { reviewer, secondReviewer, completedByDate, dialog } = actionState ?? {};
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [dialogIsOpen, setDialogOpen] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const [dialogState, setDialogState] = useState(null);
  const [data, setData] = useState([]);
  const [localError, setLocalError] = useState(false);
  const alert = useAlertHandling({ state: dialogState, alert: dialogState?.alert} || null )

  const typeState = useGetSelector({ type: dialog?.type });
  const handleInitialDialogClose = () => {
    setReviewer('')
    setDialogOpen(false);
    setLocalError(false)
    setData([])
    if (dialog?.type === CREATE_TRAINING || dialog?.type === ASSIGN_TRAINEE) {
      dispatch(createTrainingAction({
        ...dialogState,
        status: '',
        alert: dialogState?.status === STATUS?.SUCCESS ? dialogState?.alert : ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
        allReviewers: true, 
        emplids: [],
        expectedRecommendation: '',
        details: '',
      }));
    } else if (dialog?.type === UNASSIGN_TRAINEE) {
      dispatch(unassignTraineeAction({
        ...dialogState,
        status: '',
        alert: dialogState?.status === STATUS?.SUCCESS ? dialogState?.alert : ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
        emplids: [],
        details: '',
      })); 
    } else if (dialog?.type === EDIT_TRAINING) {
      dispatch(editTrainingAction({
        status: null,
        alert: dialogState?.status === STATUS?.SUCCESS ? dialogState?.alert : ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
        details: '',
        expectedRecommendation: '',
        previousExpectedRecommendation: '',
      }));
    } else if (dialog?.type !== OVERRIDE_RECOMMENDATION) {
      dialogState?.status?.toUpperCase() !== STATUS?.SUCCESS &&
        dispatchByType(dialogState?.type, {
          ...dialogState,
          status: null,
          alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
          details: '',
        });
      }
    }
  const handleSuccessDialogClose = (type) => {
    setSuccessDialog(false);
    setDialogState(null);
    dispatchByType(dialogState?.type, {
      status: null,
      alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
      details: '',
    });
    
    // For the different types, look for DialogContent within this file and within actions.js; ignore SUBMIT_RECOMMENDATION, SAVE_REVIEW, NOTIFY_ADMIN (we redirect in those cases)
    const refreshPageDataTypes = [ASSIGN_APPLICATION, REASSIGN_APPLICATION, UNASSIGN_APPLICATION, RESTART_APPLICATION, CREATE_TRAINING, ASSIGN_TRAINEE, UNASSIGN_TRAINEE, UPDATE_PRIORITY, CLEAR_NOTIFY_ADMIN, RESTART_APPLICATION];
    if (refreshPageDataTypes.includes(type)) {
        // Invalidate RTK Query cache to trigger a refetch of the application data
        dispatch(graphqlApi.util.invalidateTags([
          { type: 'Applicant', id: pageAppHeader?.emplId },
        ]));
    }

    const stayOnApplicantPageTypes = [ASSIGN_APPLICATION, REASSIGN_APPLICATION, UNASSIGN_APPLICATION, RESTART_APPLICATION, UPDATE_PRIORITY, CLEAR_NOTIFY_ADMIN, CREATE_TRAINING, UNASSIGN_TRAINEE, EDIT_TRAINING];
    if(!stayOnApplicantPageTypes.includes(type))
      navigate("/");
  };

  const { committeeName, recommendationHistory } = useSelector((state) => {
    return {
      committeeName: state?.studentData?.student?.data?.committeeDetails?.committeeName ?? "MISSING LABEL",
      recommendationHistory: state?.studentData?.student?.data?.recommendationHistory ?? [],
    };
  });

  useEffect(() => {
    if (dialogState !== typeState) {
      setDialogState(typeState)
    }
  }, [typeState]);

  useEffect(() => {
    if (
      dialogState?.status && dialogState?.status?.toUpperCase() === STATUS?.SUCCESS
    ) {
      handleInitialDialogClose();
      setSuccessDialog(true);
    }
    if (
      dialogState?.status?.toUpperCase() === STATUS?.CANCEL
    ) {
      handleInitialDialogClose();
    }
    
  }, [dialogState?.status, dispatch]);
  
  const DialogContent = () => {
    if (dialogState?.type === ASSIGN_APPLICATION) {
      return (
        <>
          <AutoComplete id="auto-complete-reviewer" reviewer={reviewer} setReviewer={setReviewer} type={dialog?.type} />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              className='a11y-button-reset'
              format="MM/dd/yyyy"
              label="Complete by"
              value={completedByDate}
              minDate={new Date()}
              onChange={handleCompletedByDateChange}
              slotProps={{
                textField: {
                  variant: "outlined",
                  required: true,
                  style: { marginTop: "1em", width: "100%" }
                },
                openPickerButton: { 'aria-label': 'change date' }
              }}
            />
          </LocalizationProvider>
        </>
      );
    } else if (dialogState?.type === UNASSIGN_APPLICATION) {
      return (
        <AutoComplete
          id="auto-complete-reviewer"
          reviewer={reviewer}
          setReviewer={setReviewer}
          type={dialog?.type}
        />
      );
    } else if (dialog?.type === UNASSIGN_TRAINEE) {
      return <UnassignTraineeDialogContent  isTraining={isTraining} />;
    } else if (dialog?.type === EDIT_TRAINING) {
      return <EditTrainingDialogContent  isTraining={isTraining} />;
    } else if (dialog?.type === NOTIFY_ADMIN) {
      return <NotifyAdminDialogContent data={data} setData={setData} localError={localError} setLocalError={setLocalError} />;
    } else if (dialog?.type === CLEAR_NOTIFY_ADMIN) {
      return <ClearNotifyAdminDialogContent recommendationHistory={recommendationHistory} />
    } else if (dialog?.type === REASSIGN_APPLICATION) {
      return (<>
        <Mui.Typography>From</Mui.Typography>
        <AutoComplete
          className={"margin-bottom-1"}
          id="auto-complete-reviewer"
          reviewer={reviewer}
          setReviewer={setReviewer}
          type={UNASSIGN_APPLICATION}
        />
        <Mui.Typography>To</Mui.Typography>
        <AutoComplete
          id="auto-complete-reviewer-two"
          reviewer={secondReviewer}
          setReviewer={setSecondReviewer}
          type={dialog?.type}
        />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            className='a11y-button-reset' 
            format="MM/dd/yyyy"
            label="Complete by"
            value={completedByDate}
            minDate={new Date()}
            onChange={handleCompletedByDateChange}
            slotProps={{
              textField: {
                variant: "outlined",
                required: true,
                style: { marginTop: "1em", width: "100%" }
              },
              openPickerButton: { 'aria-label': 'change date' }
            }}
          />
        </LocalizationProvider>
      </>)
    } else {
      return <></>;
    }
  };

  const handleMenuChange = ({ type }) => {
    
    setMenuAnchorEl(null);

     // Reset EDIT_TRAINING state before opening dialog in case user wants to edit training again immediately
    if (type === EDIT_TRAINING) {
      dispatch(editTrainingAction({
        status: '',
        alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
        details: '',
        expectedRecommendation: '',
        previousExpectedRecommendation: '',
      }));
  }
    setActionState({
      type: MENU_CHANGE,
      payload: {
        menuType: type,
        pageAppHeader,
      },
    });
    setDialogOpen(true);
  };

  const setReviewer = (reviewer) => {
    setActionState({
      type: SELECT_REVIEWER,
      payload: reviewer,
    });
    setSubmitError(false);
  };

  const setSecondReviewer = (reviewer) => {
    setActionState({
      type: SELECT_SECOND_REVIEWER,
      payload: reviewer,
    });
    setSubmitError(false);
  };
  
  const handleCompletedByDateChange = completedByDate => {
    setActionState({
      type: SELECT_COMPLETEDBYDATE,
      payload: completedByDate,
    });
    setSubmitError(false);
  };

  return (
    <React.Fragment>
      <Menu
        selectMenuItem={handleMenuChange}
        menuAnchorEl={menuAnchorEl}
        setMenuAnchorEl={setMenuAnchorEl}
        isTraining={isTraining}
        pageAppHeader={pageAppHeader}
      />
      {dialog?.type && (
        <Dialog
          data={data}
          localError={localError}
          open={dialogIsOpen}
          onClose={handleInitialDialogClose}
          title={dialog.title}
          type={dialog.type}
          isTraining={isTraining}
          reviewer={reviewer}
          secondReviewer={secondReviewer}
          completedByDate={completedByDate}
          pageAppHeader={pageAppHeader}
          submitError={submitError}
          setSubmitError={setSubmitError}
          committeeName={committeeName}
          dialogState={dialogState}
          setDialogState={setDialogState}
          description={
            typeof dialog.description === 'function'
              ? dialog.description({
                committeeName,
                reviewer,
              })
              : dialog.description
          }
        >
          {[CREATE_TRAINING, ASSIGN_TRAINEE].includes(dialog?.type) ?
              <CreateTrainingDialogContent isTraining={isTraining} /> : <DialogContent />}
        </Dialog>
      )}
      {successDialog && (
        <Mui.Dialog
          open={successDialog}
          dialogState={dialogState}
          fullWidth
          maxWidth="sm"
        >
          {alert}
          <Mui.DialogContent>
            <Mui.DialogContentText id="alert-dialog-description">
              {dialogState?.alert?.MESSAGE}
            </Mui.DialogContentText>
          </Mui.DialogContent>
          <Mui.DialogActions className="padding-2">
            <Mui.Button onClick={() => handleSuccessDialogClose(dialogState?.type)}>
              Close
            </Mui.Button>
          </Mui.DialogActions>
        </Mui.Dialog>
      )}
    </React.Fragment>
  );
};

export default Actions;
